<script>
  /* Executable code section of the program */
  //Tools importation
  import { onMount } from "svelte";
  import {
    isProtectedRoute,
    userLocalData,
    isEmptyChatBox,
    temporalChatAttendee,
    chatsActive,
    userRealTime,
    allChats
  } from "../../apis/storage";
  import { getLocalData, auth, getOneDocument, getCollection, getSpecificDocuments } from "../../apis/APIS";
  import {getLastMessage} from "../../apis/apisChat"
  import { onAuthStateChanged } from "firebase/auth";
  import { navigate } from "svelte-routing";

  //Components importation
  import Loader from "../Loader.svelte";
  import ChatCards from "../Cards/ChatCards.svelte";
  import UnreadChatCard from "../Cards/UnreadChatCard.svelte";
  import EmptyListChat from "../EmptySections/EmptyListChat.svelte";
  import EmptyChat from "../EmptySections/EmptyChat.svelte";
  import ChatComponent from "./ChatComponent.svelte";
  import ChatCentralPhone from "./ChatCentralPhone.svelte";


  //Auxiliary variabels
  let isLoadedContent = false;
  let realTimeEvents =[]
  $: chats = $allChats
  let otherChats = []
  let currentEvent
  let pathname = ""
  let typedValue;
  let myChats = []
  let unreadChats = []
  let readChats = []

// Definition of the window witdh
const windowWidth = window.innerWidth;


  //Funciton to search chats
    function normalize(text) {
    return text
      .normalize("NFD") // Separates accents
      .replace(/[\u0300-\u036f]/g, "") // Removes accents
      .toLowerCase()
      .trim();
  };
  const chatSearch = (array, typedValue) => {
    const normalizedSearch = normalize(typedValue);

    $allChats = array.filter((item) => {
      const name = normalize(item.name || "");
      const surname = normalize(item.surname || "");

      return (
        name.includes(normalizedSearch) || surname.includes(normalizedSearch)
      );
    });
  };
  
  //Function to go back
  const goBack= () => {
    window.history.back();
  }

  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments("users","email",user.email)
        pathname = window.location.pathname.split("/")[2];

        if (pathname !== "" && $userLocalData[0].userRole === "attendee") {
        currentEvent = await getOneDocument("events",pathname)
        $chatsActive = currentEvent.activeChat
        }

        if ($userLocalData[0].userRole === "attendee") {
          
          myChats = $userLocalData[0].myChats.filter(element=>element.eventTittle === currentEvent.tittle  || element.event === currentEvent.tittle )
          otherChats = $userLocalData[0].myChats.filter(element => currentEvent.tittle !== element.eventTittle && currentEvent.tittle !== element.event);
          for (let i = 0; i < otherChats.length; i++) {
            let activeUser = await getOneDocument("users",otherChats[i].id)
            if (Object.keys(activeUser).length>0) {
              
            if (activeUser.eventList.includes(currentEvent.tittle)) {
              
              myChats = [...myChats,otherChats[i]]
            }
            }
          }
          $allChats = myChats
        }
        else{
          myChats = $userLocalData[0].myChats
          $allChats = myChats
        }
        
        for (let i = 0; i < myChats.length; i++) {
            let lastMessage = await getLastMessage(myChats[i].chatId)
            let lastReadMessage = localStorage.getItem(`lastMessage-${myChats[i].chatId}`)
            /* console.log(lastMessage,lastReadMessage);
            console.log(typeof(lastMessage)); */
            /*console.log(lastMessage); 
            const {timestamp} = lastMessage
            console.log(timestamp); */

            if (lastMessage) {
              if (Number(lastReadMessage) < lastMessage.timestamp) {
                myChats[i].status = "unread"
                unreadChats.push(myChats[i])
              } else {
                myChats[i].status = "read"
                readChats.push(myChats[i])
              }
            }
            else{
              readChats.push(myChats[i])
            }
          }
            console.log(unreadChats);
            console.log(readChats);
          allChats.set([...unreadChats,...readChats])
        
        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isLoadedContent}
    <section class="principalContainer">
      <div class="backBtnContainer">
        <button class="backBtn" on:click="{goBack}"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
        </svg> Go Back</button>
      </div>
      <div class="contentContainer">
        <div class="headerContent"><h2>Messagges</h2></div>
        {#if /* myChats !== undefined || */ myChats.length > 0}
          {#if windowWidth > 700}
            <div class="bodyContent">
              <div class="chatsContainer">
                <div class="inputContainer">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control"
                      id="floatingInput"
                      placeholder="Search"
                      bind:value={typedValue}
                      on:input={()=> chatSearch(myChats,typedValue)}
                    />
                    <label for="floatingInput">Search</label>
                  </div>
                </div>
                <!-- {#each $allChats as activeChats}
                {#if activeChats.status === "unread"}
                <UnreadChatCard chat={activeChats} />
                  {:else}
                  <ChatCards chat={activeChats} />
                {/if}
                {/each} -->
                {#each $allChats as activeChats}
                  <ChatCards chat={activeChats} />
                {/each}
              </div>
              {#if $isEmptyChatBox}
              {#key $temporalChatAttendee}
              <div class="bodyChat">
                <ChatComponent />
              </div>
              {/key}
              {:else}
                <EmptyChat />
              {/if}
            </div>
          {:else}
            <ChatCentralPhone activeChats={$allChats} />
          {/if}
        {:else}
          <EmptyListChat />
        {/if}
      </div>
    </section>
  {:else}
    <Loader />
  {/if}
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
    min-height: 100%;
    background-color: #f4f4f4;
    padding: 10px 30px;
  }
  /* Back Button styles */
    .backBtnContainer{
    width: 65%;
    display: flex;
    justify-content: flex-start;
    padding: 20px 0;
  }
  .backBtn{
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover{
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  /* Content styles */
  .contentContainer {
    background-color: white;
    width: 65%;
    height: 100dvh;
    max-height: auto;
  }
  /* Header */
  .headerContent {
    width: 100%;
    padding: 10px;
    height: auto;
  }
  h2 {
    border-bottom: 1px solid gray;
    padding: 10px;
  }
  /* Body */
  .bodyContent {
    padding: 15px;
    width: 100%;
    height: auto;
    display: flex;
  }
  /* Input container */
  .inputContainer{
    padding: 10px;
  }
  .chatsContainer {
    width: 40%;
    height: 500px;
    overflow: auto;
    border-right: 1px solid gray;
  }
  .bodyChat {
    width: 60%;
    height: 500px;
    padding: 0 15px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Content styles */
    .contentContainer {
      background-color: white;
      width: 90%;
      height: 100%;
      max-height: auto;
    }
    .chatsContainer {
      width: 50%;
      height: 500px;
      overflow: auto;
    }
    .bodyChat {
      width: 50%;
      height: 500px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Content styles */
  .principalContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
    min-height: 100%;
    background-color: #f4f4f4;
    padding: 10px;
  }
    .contentContainer {
      background-color: white;
      width: 100%;
      height: 100%;
      max-height: auto;
    }
  .bodyContent {
    padding: 5px;
    width: 100%;
    height: auto;
    display: flex;
  }
  }

  /* End of the section */
</style>
